import { Stack, Typography } from '@mui/material'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'

export const DefaultNoRowsState = () => {
  const { t } = useTranslation('requests')
  return (
    <Stack justifyContent="center" alignItems="center" gap={5} sx={{ mt: 0, height: '100%' }}>
      <Image src="/app/assets/table_empty_state.png" alt="welcome" height={160} width={140} />
      <Typography variant="upsized-medium" color="text.default">
        {t('table.empty-row')}
      </Typography>
    </Stack>
  )
}
